import { render } from "./form-course.vue?vue&type=template&id=0c5dd3ab&ts=true"
import script from "./form-course.vue?vue&type=script&lang=ts"
export * from "./form-course.vue?vue&type=script&lang=ts"

import "./form-course.vue?vue&type=style&index=0&id=0c5dd3ab&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__